module.exports = __webpack_public_path__ + "img/fdek.0f36044c.png";